const smtPqAboutUsSection = {
    description: {
        color: {
            default: 'gray.900',
            _dark: 'gray.400'
        },
    },
    testimonial: {
        heading: {
            color: {
                default: 'brand.500',
                _dark: 'brand.600'
            }
        }
    }
}

export default smtPqAboutUsSection;